"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RunProofOfWork = exports.POWIsValid = void 0;
var js_sha3_1 = require("js-sha3");
function hashWith(challenge, nonce) {
    return js_sha3_1.sha3_512(toHex(challenge + nonce));
}
function toHex(s) {
    // utf8 to latin1
    s = unescape(encodeURIComponent(s));
    var h = '';
    for (var i = 0; i < s.length; i++) {
        h += s.charCodeAt(i).toString(16);
    }
    return h;
}
function fromHex(h) {
    var s = '';
    for (var i = 0; i < h.length; i += 2) {
        s += String.fromCharCode(parseInt(h.substr(i, 2), 16));
    }
    return decodeURIComponent(escape(s));
}
function POWIsValid(result) {
    if (!result) {
        return false;
    }
    if (result.hash === '' || result.nonce === '' || result.challenge.difficulty < 1) {
        return false;
    }
    var computed = hashWith(result.challenge.challenge, result.nonce);
    if (computed !== result.hash) {
        return false;
    }
    var prefix = "0";
    return result.hash.startsWith(prefix.repeat(result.challenge.difficulty));
}
exports.POWIsValid = POWIsValid;
function RunProofOfWork(challenge) {
    for (var i = 0; true; i++) {
        var res = {
            challenge: __assign({}, challenge),
            hash: hashWith(challenge.challenge, i.toString()),
            nonce: i.toString(),
        };
        if (POWIsValid(res)) {
            return res;
        }
    }
}
exports.RunProofOfWork = RunProofOfWork;
